"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createD2CMessage = exports.createC2DMessage = exports.createSetOperatingModeCommand = exports.GetStateCommand = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const class_1 = require("../../device/class");
const message_1 = require("./message");
exports.NAMESPACE = 'Culligan.Protocol.V2.State';
exports.GetStateCommand = effect_1.Schema.Struct({ command: effect_1.Schema.tag('state.get') }).annotations({
    identifier: `${exports.NAMESPACE}.GetStateCommand`,
});
const createSetOperatingModeCommand = (state) => effect_1.Schema.Struct({
    command: effect_1.Schema.tag('operating_mode.set'),
    params: state.pipe(effect_1.Schema.pick('operatingMode')),
});
exports.createSetOperatingModeCommand = createSetOperatingModeCommand;
const createC2DMessage = (state) => (0, message_1.createMessage)('command', effect_1.Schema.Union(exports.GetStateCommand, (0, exports.createSetOperatingModeCommand)(state)));
exports.createC2DMessage = createC2DMessage;
const createD2CMessage = (state) => (0, message_1.createMessage)('state', state.pipe(effect_1.Schema.extend(class_1.Base.CommonProps.pick('swVersion', 'hwVersion')), effect_1.Schema.encodedBoundSchema, effect_1.Schema.partialWith({ exact: true }))).annotations({
    title: 'State Message',
    description: 'A Device-To-Cloud message on the "state" channel',
});
exports.createD2CMessage = createD2CMessage;
//# sourceMappingURL=state.js.map